export default "__VITE_ASSET__mnhoJ4rS__"